import {
	AccordionActions,
	AccordionDetails,
	AccordionSummary,
	Accordion,
	Box,
	Button,
	Typography,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { useNetwork } from "../../providers/NetworkProvider";
import { useSnackbar } from "../../providers/SnackbarProvider";
import SetupIntentForm from "../../components/stripe/StripeCard";
import ComputerIcon from "@mui/icons-material/Computer";
import RocketLaunchIcon from "@mui/icons-material/RocketLaunch";
import { useAuth } from "../../providers/AuthenticationProvider";
import PricingPlan from "../PricingPlan";

const AccordionPay = () => {
	const { t } = useTranslation();
	const { openLoadingSnackbar, closeLoadingSnackbar } = useSnackbar();
	const { userSubscription, user, profile } = useAuth();
	const { makePost } = useNetwork();

	const upgradeHandler = async (priceId: string) => {
		if (user == null) return;
		let stripeSessionUrl = "";
		try {
			openLoadingSnackbar();
			const tokenId = await user.getIdToken();

			const res = await makePost(
				"payments/stripe/upgradeSubscription",
				{ newPriceId: priceId },
				tokenId
			);
			console.log(res.status);
			console.log(res.data);
			stripeSessionUrl = res.data.sessionUrl;
		} catch (err) {
			console.log(err);
		} finally {
			closeLoadingSnackbar();
		}
		if (stripeSessionUrl != null && stripeSessionUrl != "") {
			window.location.href = stripeSessionUrl;
		}
	};
	if (
		profile == null ||
		profile.initalFeePaid == null ||
		!profile.initalFeePaid
	)
		return <PricingPlan />;

	return (
		<>
			<Typography
				variant="h4"
				sx={{
					fontFamily: "Work Sans !important",
					fontWeight: "bold",
					fontSize: window.innerWidth < 600 ? "24px" : "28px",
				}}
			>
				{t("userDashboard.upgrada.title")}
			</Typography>
			<Typography
				sx={{
					fontFamily: "Work Sans !important",
					marginBottom: "16px",
				}}
			>
				{t("userDashboard.upgrada.text")}
			</Typography>

			<Accordion
				sx={{
					backgroundColor: "transparent",
					backgroundImage: "none",
					boxShadow: "none",
				}}
			>
				<AccordionSummary
					expandIcon={<ExpandMoreIcon />}
					aria-controls="panel1-content"
					id="panel1-header"
					sx={{
						backgroundColor: "transparent",
						fontWeight: "bold",
					}}
				>
					Basic
				</AccordionSummary>
				<AccordionDetails>
					{t("AccordionPlan.Basic")}

					<Button
						onClick={async () => {
							await upgradeHandler(
								"price_1P7JXKANVtnBUNBJ3gFChoXP"
							);
						}}
						color="secondary"
					>
						Upgrade to Basic
					</Button>
				</AccordionDetails>
			</Accordion>
			<Accordion
				sx={{
					backgroundColor: "transparent",
					backgroundImage: "none",
					boxShadow: "none",
				}}
			>
				<AccordionSummary
					expandIcon={<ExpandMoreIcon />}
					aria-controls="panel2-content"
					id="panel2-header"
					sx={{
						backgroundColor: "transparent",
						fontWeight: "bold",
					}}
				>
					Premium
				</AccordionSummary>
				<AccordionDetails>
					{t("AccordionPlan.Premium")}

					<Button
						onClick={async () => {
							await upgradeHandler(
								"price_1PD30pANVtnBUNBJbL4qogjv"
							);
						}}
						color="secondary"
					>
						Upgrade to Premium
					</Button>
				</AccordionDetails>
			</Accordion>
			<Accordion
				sx={{
					backgroundColor: "transparent",
					backgroundImage: "none",
					boxShadow: "none",
				}}
			>
				<AccordionSummary
					expandIcon={<ExpandMoreIcon />}
					aria-controls="panel3-content"
					id="panel3-header"
					sx={{
						backgroundColor: "transparent",
						fontWeight: "bold",
					}}
				>
					Enterprise
				</AccordionSummary>
				<AccordionDetails>
					{t("AccordionPlan.Enterprise")}
					<Button
						onClick={async () => {
							await upgradeHandler(
								"price_1PD31LANVtnBUNBJRc4Kad7S"
							);
						}}
						color="secondary"
					>
						Upgrade to Enterprise
					</Button>
				</AccordionDetails>
			</Accordion>
		</>
	);
};

export default AccordionPay;
